import { number, string } from "yup";

export interface IItemNumber {
  [key: number]: any;
}

export interface IItemString {
  [key: string]: any;
}

export interface ICountry {
  id: string;
  name: string;
  logo?: string;
}
export interface ITeam {
  id: string;
  name: string;
  short_name?: string;
  short_name_vi?: string;
  logo?: string;
  sub_ids?: string[];
  country_id?: string;
  country?: ICountry;
}

export interface ICommentator {
  id: number;
  name: string;
  avatar: string;
}

export interface IRound {
  group_num: number;
  round_num: number;
  stage_id: string;
}

export interface IStage {
  id: string;
  group_count: number;
  mode: number;
  name: string;
  name_vi: string;
  order: number;
  round_count: number;
  season_id: string;
}

export interface ICarousel {
  competition_id: string;
  states: Array<IStage>;
}

export interface ITag {
  title: string;
  value: string;
}

export interface ILeague {
  id: string;
  name: string;
  category_id?: string;
  logo?: string;
  parent_id?: string;
}

export interface IFilterResult {
  competition_id: string;
  tag?: ITag | null;
  league?: ILeague | null;
}

export interface IMatchTimePlayer {
  text: string;
  process: number;
  status_h2h?: string;
}

export interface IVenue {
  _id: string;
  id: string;
  capacity: number;
  city: string;
  country: string;
  country_id: string;
  name: string;
}

export interface IReferee {
  id: string;
  name: string;
  name_vi: string;
  country_id?: string;
  yellow_card_percent?: any;
  red_card_percent?: any;
}

export interface IEnvironment {
  weather: number;
  pressure: string;
  temperature: string;
  wind: string;
  humidity: string;
}

export interface IMatch {
  id: string;
  competition_id: string;
  commentator_id?: number | null;
  home_team: ITeam;
  away_team: ITeam;
  home_scores?: Array<number> | [];
  away_scores?: Array<number> | [];
  agg_score?: Array<number> | [];
  match_time: number;
  round?: IRound;
  stage?: IStage;
  status_id: number;
  competition?: ILeague;
  season_id?: string;
  home_team_id: string;
  away_team_id: string;
  leg?: string;
  is_hot?: number;
  slug?: string;
  title?: string;
  match_time_player?: IMatchTimePlayer;
  venue?: IVenue;
  referee?: IReferee;
  environment?: IEnvironment;
  coach?: {
    home: ICoach;
    away: ICoach;
  };
  scores?: IScores;
}

export interface IMatchLiveData {
  competitions: Array<ILeague>;
  commentators: Array<ICommentator>;
  teams: Array<ITeam>;
  matches: Array<IMatch>;
}

export interface IMatchMapping {
  _id: string;
  thesports_uuid: string;
  is_same: string;
  match_id: number;
}

export interface IMatchLive {
  id: string;
  score: Array<any>;
  away_scores: Array<number>;
  stats: Array<object>;
  incidents: Array<any>;
  timer: Array<any>;
}

export interface ICompetitions {
  id: string;
  name: string;
  short_name?: string;
  short_name_vi?: string;
  matchs: Array<IMatch>;
  type?: number;
  popularity?: any;
  primary_color?: any;
  secondary_color?: any;
  cur_season_id?: any;
  title?: string | null;
  isShowLogo?: boolean;
  date?: string;
}

export interface ICompetition {
  id: string;
  name: string;
  short_name?: string;
  short_name_vi?: string;
  type?: number;
  popularity?: any;
  primary_color?: any;
  secondary_color?: any;
  cur_season_id?: any;
}

export interface IPlayer {
  id: string;
  short_name: string;
  short_name_vi: string;
  name: string;
  position: string | any;
  rating: string;
  shirt_number: number;
  x: number;
  y: number;
  incidents: Array<IIncident>;
}

export interface IIncident {
  type: number;
  position: number;
  time: number;
  home_score: number;
  away_score: number;
  player: IPlayer;
  playerOut: IPlayer;
  playerIn: IPlayer;
  in_player: IPlayer;
  out_player: IPlayer;
}

export interface IStatistics {
  id: string | number | symbol | undefined;
  matchStatus: string | number | undefined;
  score: Array<any>;
  stats: Array<any>;
  homeData: {
    aces: number | 0;
    first_serve_success: number | 0;
    first_serve_total: number | 0;
    first_serve_rate: number | 0;
    second_serve_success: number | 0;
    second_serve_total: number | 0;
    second_serve_rate: number | 0;
    break_points_success: number | 0;
    break_points_total: number | 0;
    break_points_rate: number | 0;
    double_faults: number | 0;
    unforced_err: number | 0;
    points_won: number | 0;
    first_serve_points_success: number | 0;
    first_serve_points_rate: number | 0;
    second_serve_points_success: number | 0;
    second_serve_points_rate: number | 0;
    max_points_in_a_row: number | 0;
    receiver_points_won: number | 0;

    first_serve: number | 0;
    second_serve: number | 0;
    break_points: number | 0;
    break_points_percent: number | 0;
    total_points: number | 0;
    first_serve_points: number | 0;
    second_serve_points: number | 0;
  };
  awayData: {
    aces: number | 0;
    first_serve_success: number | 0;
    first_serve_total: number | 0;
    first_serve_rate: number | 0;
    second_serve_success: number | 0;
    second_serve_total: number | 0;
    second_serve_rate: number | 0;
    break_points_success: number | 0;
    break_points_total: number | 0;
    break_points_rate: number | 0;
    double_faults: number | 0;
    unforced_err: number | 0;
    points_won: number | 0;
    first_serve_points_success: number | 0;
    first_serve_points_rate: number | 0;
    second_serve_points_success: number | 0;
    second_serve_points_rate: number | 0;
    max_points_in_a_row: number | 0;
    receiver_points_won: number | 0;

    first_serve: number | 0;
    second_serve: number | 0;
    break_points: number | 0;
    break_points_percent: number | 0;
    total_points: number | 0;
    first_serve_points: number | 0;
    second_serve_points: number | 0;
  };
}

export interface IStatsJsonData {
  id: string | number | symbol | undefined;
  matchStatus: string | number | undefined;
  score: {
    home: string | number | undefined;
    away: string | number | undefined;
  };
  stats: Array<any>;
  homeData: {
    aces: number | 0;
    first_serve_success: number | 0;
    first_serve_total: number | 0;
    first_serve_rate: number | 0;
    second_serve_success: number | 0;
    second_serve_total: number | 0;
    second_serve_rate: number | 0;
    break_points_success: number | 0;
    break_points_total: number | 0;
    break_points_rate: number | 0;
    double_faults: number | 0;
    unforced_err: number | 0;
    points_won: number | 0;
    first_serve_points_success: number | 0;
    first_serve_points_rate: number | 0;
    second_serve_points_success: number | 0;
    second_serve_points_rate: number | 0;
    max_points_in_a_row: number | 0;
    receiver_points_won: number | 0;
  };
  awayData: {
    aces: number | 0;
    first_serve_success: number | 0;
    first_serve_total: number | 0;
    first_serve_rate: number | 0;
    second_serve_success: number | 0;
    second_serve_total: number | 0;
    second_serve_rate: number | 0;
    break_points_success: number | 0;
    break_points_total: number | 0;
    break_points_rate: number | 0;
    double_faults: number | 0;
    unforced_err: number | 0;
    points_won: number | 0;
    first_serve_points_success: number | 0;
    first_serve_points_rate: number | 0;
    second_serve_points_success: number | 0;
    second_serve_points_rate: number | 0;
    max_points_in_a_row: number | 0;
    receiver_points_won: number | 0;
  };
}

export interface ILiveScore {
  home_team_id: string;
  away_team_id: string;
  home_scores: Array<number>;
  away_scores: Array<number>;
}

export interface IStandingsRow {
  team_name?: string;
  team_id: string;
  total: string;
  home_total: string;
  away_total: string;
  won: string;
  home_won: string;
  away_won: string;
  draw: string;
  home_draw: string;
  away_draw: string;
  loss: string;
  lost?: string | number;
  home?: string;
  away?: string;
  home_loss: string;
  away_loss: string;
  goals: string;
  home_goals: string;
  away_goals: string;
  goals_against: string;
  home_goals_against: string;
  away_goals_against: string;
  goal_diff: string;
  home_goal_diff: string;
  away_goal_diff: string;
  points: string;
  home_points: string;
  away_points: string;
  promotion_id: string;
  position: number;
  home_position: number;
  away_position: number;
  recent_matches: Array<IRecent>;
  next_match: IMatch;
  home_matches: Array<Object>;
  away_matches: Array<Object>;
  live_score?: ILiveScore;
  game_back?: string | number;
  division?: string | number;
  conference?: string | number;
  streaks?: string | number;
  won_rate?: number;
  diff_avg?: number;
  points_avg: number;
  points_agt?: number;
  next?: any;
}

export interface IRecent {
  away_scores: Array<number>;
  home_scores: Array<number>;
  away_team: ITeam;
  home_team: ITeam;
  match_time: number;
}

export interface IStandingsTable {
  rows: Array<IStandingsRow>;
  group: number;
}

export interface IPromotion {
  id: string;
  name: string;
  color: string;
}

export interface IStandings {
  rows: Array<IStandingsRow>;
}

export interface IStanding {
  standings: [IStandings];
  teams: Array<ITeam>;
}

export interface IIncident {
  type: number;
  minute: number;
  belong: number;
}

export interface IPlayer {
  id: string;
  first?: any;
  name: string;
  name_vi: string;
  position: string | any;
  logo: string;
  type: number;
  reason: string;
  start_time: number;
  end_time: number;
  missed_matches: number;
  short_name: string;
  incidents: Array<IIncident>;
}

export interface ICoach {
  id: string;
  name: string;
  team_id: string;
  age: number;
  logo: string;
  country_id: string;
}

export interface ILineupsPlayer {
  id: string;
  name: string;
  logo: string;
  jersey_nmber: string;
  data: {
    duration_of_presence: number;
    hits_shots: number;
    three_pointers: string;
    free_throws: string;
    offensive_rebound: number;
    defensive_rebound: number;
    total_rebounds: number;
    assists: number;
    steals: number;
    blocks: number;
    number_of_errors: number;
    individual_fouls: number;
    value: number;
    score: number;
    whether_to_play: number;
    whether_on_the_field: number;
    whether_it_is_a_substitute: number;
  };
}

export interface ILineupData {
  home: ILineupsPlayer[];
  away: ILineupsPlayer[];
}

export interface ILineups {
  id: string;
  players: ILineupData;
}

export interface IIncidentStatistic {
  type: number;
  label: string;
  icon: any;
  player?: {
    id: string;
    name: string;
    name_vi: string;
  };
  in_player?: {
    id: string;
    name: string;
  };
  out_player?: {
    id: string;
    name: string;
  };
  assist1?: {
    id: string;
    name: string;
  };
}

export interface IOdd {
  [key: string]: string;
  id: string;
  encode_is_id: string;
  asian_hdp: string;
  asian_hdp_home: string;
  asian_hdp_away: string;
  asian_close: string;
  european_home: string;
  european_draw: string;
  european_away: string;
  european_close: string;
  over_under_hdp: string;
  over: string;
  under: string;
  over_under_close: string;
}

export interface IOddItem {
  early: any[];
  live: any[];
  run: any[];
}

export interface IOddMatch {
  id: string;
  company_id: string;
  asia: IOddItem;
  eu: IOddItem;
  bs: IOddItem;
  cr: IOddItem;
}

export interface IAnalysis {
  headToHead: Array<any>;
  homeLastMatches: Array<any>;
  awayLastMatches: Array<any>;
  awaySchedule: Array<any>;
  homeOdds: Object;
  awayOdds: Object;
  homeGoals: Object;
  awayGoals: Object;
  homeHT: Object;
  awayHT: Object;
  homeShootTime: Array<any>;
  awayShootTime: Array<any>;
  homeSingleDouble: Object;
  awaySingleDouble: Object;
  homeDataVs: Object;
}

export interface IShootingPoints {
  results: Array<any>;
  id: string;
}

export interface IShootingPointResponseData {
  match?: IMatch;
  shootingPoints?: IShootingPoints;
  listPlayer?: Array<IPlayer>;
}

export interface IPlayerDataShooting {
  id?: string;
  teamId?: string;
  scoreOfSorting?: string;
  pts?: string;
  reb?: string;
  ast?: string;
  "3pt"?: string;
  blk?: string;
  stl?: string;
  fi?: string;
  ord?: string;
  min?: string;
  fg?: string;
  oreb?: string;
  numberOfBar?: number;
  time?: number;
  totalPoint?: number;
  starter?: number | string;
}

export interface ITournamentBracket {
  id: string;
  unique_tournament_id: string;
  name: string;
  abbr: string;
  start_time: number;
  end_time: number;
}

export interface ITournamentGroup {
  id: string;
  bracket_id: string;
  start_time: number;
  end_time: number;
  type_id: number;
  number: number;
  rounds?: ITournamentRound[];
}

export interface ITournamentRound {
  id: string;
  bracket_id: string;
  group_id: string;
  name: string;
  abbr: string;
  start_time: number;
  end_time: number;
  number: number;
  match_ups?: ITournamentMatchUp[] | null;
  match_up_lines?: number | 0;
  match_up_chunks?: any;
}

export interface ITournamentMatchUp {
  id: string;
  round_id: string;
  number: number;
  type_id: number;
  state_id: number;
  home_team_id: string;
  away_team_id: string;
  winner_team_id: string;
  home_score: number;
  away_score: number;
  parent_ids: string[];
  children_ids: string[];
  match_ids: string[];
  note: string;
  home_team?: ITournamentTeam | null;
  away_team?: ITournamentTeam | null;
  i_match?: any;
}

export interface IHighestRanking {
  type_str: string;
  date: number;
  ranking: number;
}
export interface IExtraTennis {
  birthday: number;
  highest_ranking: IHighestRanking[];
}
export interface ITournamentTeam {
  sub_ids: string[];
  gender: number;
  national: number;
  id: string;
  abbr: string;
  country_id: string;
  logo: string;
  name: string;
  short_name: string;
  short_name_vi: string;
  type: number;
  updated_at: number;
  extra?: IExtraTennis;
}
export interface ITournamentJsonData {
  id: string | number | symbol | undefined;
  brackets: ITournamentBracket[];
  groups: ITournamentGroup[];
  rounds: ITournamentRound[];
  match_ups: ITournamentMatchUp[];
  teams: ITournamentTeam[];
  matches?: any[];
}

export interface IScores {
  p1: number[];
  p2: number[];
  x1: number[];
  pt: string[];
  ft: number[];
}

interface ICoverage {
  mlive: number;
}

export interface ITournament {
  id: string;
  category_id: string;
  city: string;
  competitors: number;
  end: number;
  gender: number;
  name: string;
  prize: number;
  prize_currency: string;
  qualification: number;
  season_id: string;
  sets: number;
  start: number;
  type: number;
  unique_tournament_id: string;
  updated_at: number;
  year: string;
  ground_id?: number;
}

export interface IVenue {
  id: string;
  capacity: number;
  city: string;
  name: string;
}
export interface ISeason {
  id: string;
  abbr: string;
  competition_id: string;
  end_time: number;
  is_current: number;
  name: string;
  neutral: number;
  start_time: number;
  unique_tournament_id: string;
  updated_at: number;
  year: string;
}
export interface IMatchTennis {
  id: string;
  away_team_id: string;
  bestof: number;
  coverage: ICoverage;
  home_team_id: string;
  match_time: number;
  neutral: number;
  scores: IScores;
  season_id: string;
  status_id: number;
  tournament_id: string;
  unique_tournament_id: string;
  updated_at: number;
  venue_id: string;
  tournament: ITournament | null;
  season: ISeason;
  home_team: ITournamentTeam;
  away_team: ITournamentTeam;
  venue?: IVenue;
  match_time_player?: IMatchTimePlayer;
}

// Overview
export interface IScoreDynamic {
  pt: string[];
  ft: number[];
  [key: `p${number}`]: [number, number];
  [key: `x${number}`]: [number, number];
}

export type IScoreStatistics = [string, number, number, IScoreDynamic];
export interface IStatisticsJsonData {
  id: string;
  status_id: number;
  stats: [number, [number, number, number][]][];
  score: IScoreStatistics;
  timeline: ITimeline[];
}

export interface ITimelineScore {
  home: number;
  away: number;
  serve: number;
}
export interface ITimelineRound {
  round: number;
  score: ITimelineScore;
  points: string[][];
  score_round?: {
    home: number;
    away: number;
  };
}
export interface ITimeline {
  set: number;
  rounds: ITimelineRound[];
  score_win?: {
    home: number;
    away: number;
  };
}

export interface IVS {
  id: string;
  unique_tournament_id: string;
  season_id: string;
  tournament_id: string;
  venue_id: string;
  home_team_id: string;
  away_team_id: string;
  neutral: number;
  bestof: number;
  match_time: number;
  status_id: number;
  coverage: {
    mlive: number;
  };
  scores: IScores;
  updated_at: number;
  home_team?: ITeam;
  away_team?: ITeam;
}

export interface IH2h {
  historyHomeMatches?: IVS[] | undefined;
  historyAwayMatches?: IVS[] | undefined;
  historyVSMatches?: IVS[] | undefined;
  vs: IVS[];
  home: IVS[];
  away: IVS[];
  teams: ITeam[];
  competitions: Array<ILeague>;
  tournaments: ITournament[];
  uniqueTournaments?: ITournament[];
  countries?: ICountry[];
  future: {
    home: IVS[];
    away: IVS[];
  };
}

export const convertScores = (
  scores: IScores
): Record<string, [number | string, number | string]> => {
  const result: Record<string, [number | string, number | string]> = {};

  Object.entries(scores).forEach(([key, value]) => {
    if (value.length >= 2) {
      result[key] = [value[0], value[1]]; // Lấy hai phần tử đầu tiên từ mỗi mảng
    } else {
      result[key] = [value[0] ?? "", value[1] ?? ""]; // Gán giá trị mặc định nếu không đủ phần tử
    }
  });

  return result;
};
